export default __webpack_public_path__ + "static/installatiebedrijf-b1f4d6fa5469df32d8f76f9ec49dd19c.jpg";